import { DialogueUIConfig, DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType, Window508Type } from "../CalmBaseScenario";
import Scenario5 from "./Scenario5";

export default class Scenario5Part1 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 0;
	chapterIds = {
		scenario5_1a_s1: 'CALM - Scenario 5 - 1A - Segment 1',
		scenario5_1a_s2: 'CALM - Scenario 5 - 1A - Segment 2',
		scenario5_1a_s3: 'CALM - Scenario 5 - 1A - Segment 3',
		scenario5_1a_s4a: 'CALM - Scenario 5 - 1A - Segment 4A'
	}

	constructor(scenario: Scenario5, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario5/calm-scenario5-avatar' + this.scenario.avatarIndx + '.mp4'];
	}
	public get partId(): string {
		return constants.scenarios.scenario5.parts.level5Part1.id;
	}

	public start() {
		const context = this;
		this.scenario.displayBeginScenarioUI(
			'./assets/images/scenario5/begin-scenario-scenario5.jpg',
			'calm-scenario5-begin-scenario',
			() => {
				this.scenario.playAmbientLoop(this.scenario.audioHall);
				context.segment1Step1MirandaApproaches();
			});

	}

	private segment1Step1MirandaApproaches() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.displayHeader();
		context.playVideoChapter(this.chapterIds.scenario5_1a_s1, () =>
			context.segment1Step2Dialogue())
	}

	private segment1Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.dialog(
			'CN-C08-L2-000a',
			[{
				text: 'Let’s look up our facility’s policies on transfusions.',
				isCorrect: true, // Rank best_s
				scoreType: ScoreType.Best,
			}, {
				text: 'Can I help you later?',
				feedback: 'For training purposes, let\s look up the facility\'s policies on transfusions before deciding to help the RN.',
				scoreType: ScoreType.Zero,
				isCorrect: false // Rank Zero
			}, {
				text: 'Sure! I can help you now!',
				feedback: 'For training purposes, let\s look up the facility\'s policies on transfusions before deciding to help the RN.',
				scoreType: ScoreType.Zero,
				isCorrect: false // Rank Zero
			}],
			(selectedOption: DialogueUIOptionConfig, config: DialogueUIConfig) => {
				selectedOption.hide = true; // set hide here				
				context.scenario.evaluateAnswer_s(selectedOption, () => {
					context.segment2aStep1PolicyCheck();
				}, () => {
					context.segment2aStep1PolicyCheck();
				})
				context.scenario.evaluateAnswerForSummative(selectedOption, {
					onOptionSelected: () => { },
					options: [
						{
							text: 'Let’s look up our facility’s policies on transfusions.',
							isCorrect: true
						},
						{
							text: 'Can I help you later?',
							isCorrect: false
						},
						{
							text: 'Sure! I can help you now!',
							isCorrect: false
						}
					],
					aarScenarioID: 1,
					aarSectionID: 0,
					aarCollectionID: [config.selectedAnswer]
				}, () => { },
					context.partIndx)
			}
		);
		context.scenario.updateObjective('Select your response to Miranda');
	}



	private segment2aStep1PolicyCheck() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.playVideoChapter(context.chapterIds.scenario5_1a_s2, () => {
			context.segment2aStep2ComputerResearch();
		});
		context.scenario.updateObjective('');
	}

	private segment2aStep2ComputerResearch() { // This interaction is just a scrollable text field with text		
		var context = this;
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);
		const instanceId = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: null,
			review: {
				text:
					`
					<p class="regular-description-font" style="margin: 0">
					(1) Prep the patient for transfusion <br /><br />

						A. Check patient consent.<br /><br />
					
						B. Check patient for patent IV.<br /><br />
					
					(2) Retrieve blood.<br /><br />
					
					(3) - (9) : Refer to your local Blood Transfusion Policy<br /><br />
					
					(10) Take vital signs after transfusion completed	<br /><br />
					</p>
					`
			},
			reflects: null,
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.scenario.gameManager.UiManager.destroyUIInstanceById(instanceId);
				context.segment2bstep1PolicyCheckEnd();
			}
		})
	}

	private segment2bstep1PolicyCheckEnd() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.playVideoChapter(context.chapterIds.scenario5_1a_s3, () => {
			context.segment2bStep2Dialogue();
		});
	}

	private segment2bStep2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.dialog(
			'CN-C08-L2-010b',
			[{
				text: 'You’ll have to first prep the patient for the transfusion.',
				scoreType: ScoreType.Best,
				isCorrect: true // Rank best_s
			}, {
				text: 'I’ll prep the patient for you while you get the blood.',
				feedback: 'You chose to prep the patient yourself while RN Miranda gets the blood. However, let\'s assume that you told Miranda to prep the patient.',
				scoreType: ScoreType.Zero,
				isCorrect: false // Rank Zero
			}],
			(selectedOption: DialogueUIOptionConfig, config: DialogueUIConfig) => {
				selectedOption.hide = true; // set hide here	
				context.scenario.evaluateAnswer_s(selectedOption, () =>
					context.segment3Step1MirandaDeparts(), () =>
					context.segment3Step1MirandaDeparts());
				context.scenario.evaluateAnswerForSummative(selectedOption, {
					onOptionSelected: () => { },
					options: [
						{
							text: 'You’ll have to first prep the patient for the transfusion.',
							isCorrect: true
						},
						{
							text: 'I’ll prep the patient for you while you get the blood.',
							isCorrect: false
						}
					],
					aarScenarioID: 1,
					aarSectionID: 1,
					aarCollectionID: [config.selectedAnswer]
				}, () => {}, context.partIndx)
			}
		);
		context.scenario.updateObjective('Select your response to Miranda');
	}

	private segment3Step1MirandaDeparts() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.playVideoChapter(this.chapterIds.scenario5_1a_s4a, () => {
			context.onDone();
		});
	}
}